import React, { useState, useEffect } from "react";
import axios from "../../../library/axios";
import { Table } from "react-bootstrap";
import { getSlug, } from "../../../../src/config/routes/guards/slug";

const SummaryReccomendationComp = (props) => {
  const [summaries, setSummaries] = useState({});

  const fetchSummaries = async () => {
    try {
      const options = {
        url: `/dashboard/pps/${props.idKegiatanAkreditasi}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data.data);
      setSummaries(data?.data);
    } catch (err) {
      console.log(err.message);
    }
  };

  useEffect(() => {
    fetchSummaries();
  }, []);

  return (
    <>
      <div className="col-12 mb-4">
        <h5 className="card-title mb-3">Ringkasan PPS</h5>
        <div className="table-responsive">
          <Table striped bordered hover>
            <thead className="bg-primary border-1 text-center text-white">
              <th>
                Total<br></br>Rekomendasi
              </th>
              <th>
                Total Rekomendasi<br></br>Belum Buat PPS
              </th>
              <th>
                Total Rekomendasi<br></br>Sudah Buat PPS
              </th>
              <th>
                Total PPS<br></br>Kategori Pelaksanaan
              </th>
              <th>
                Total PPS<br></br>Kategori Fasilitas
              </th>
              <th>
                Total PPS<br></br>Kategori Dokumen
              </th>
            </thead>
            <tbody className="border-1">
              <tr>
                <td className="text-center">
                  <span className="badge bg-info">
                    {summaries.totalReccomendation} Item
                  </span>
                </td>
                <td className="text-center">
                  <span className="badge bg-danger">
                    {summaries.totalReccomendationNullPps} Item
                  </span>
                </td>
                <td className="text-center">
                  <span className="badge bg-success">
                    {summaries.totalReccomendationNotNullPps} Item
                  </span>
                </td>
                <td className="text-center">
                  <span className="badge badge-light-dark">
                    {summaries.totalPpsPelaksanaan} Item
                  </span>
                </td>
                <td className="text-center">
                  <span className="badge badge-light-dark">
                    {summaries.totalPpsFasilitas} Item
                  </span>
                </td>
                <td className="text-center">
                  <span className="badge badge-light-dark">
                    {summaries.totalPpsDokumen} Item
                  </span>
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </div>
      <hr></hr>
    </>
  );
};

export default SummaryReccomendationComp;
